import { ResultatRechercheModel } from '../types/rechercheModel'

export const INITIAL_RESULTAT_RECHERCHE: ResultatRechercheModel = {
	offresExactes: [],
	offresApprochantes: [],
	totalOffresExactes: 0
}

export const URL_PARAMS_FILTRES: string = 'filtres'